// Well this data structure could be improved, it turns out!

export const AREAS = [
    'North East',
    'London',
    'South East',
    'Midlands and East Anglia',
    'South West',
    'Wales',
    'Scotland',
    'Ireland',
    'Northern Ireland',
    'North West',
];

export const AREA_IDS = [
    'ne',
    'l',
    'se',
    'mid',
    'sw',
    'w',
    's',
    'i',
    'ni',
    'nw',
];

export const AREAS_OBJ = {
    ne: 'North East',
    l: 'London',
    se: 'South East',
    mid: 'Midlands + East Anglia',
    sw: 'South West',
    w: 'Wales',
    s: 'Scotland',
    i: 'Ireland',
    ni: 'Northern Ireland',
    nw: 'North West',
}

export const VOTE_AREAS_BUTTON_ORDER = [
    {
        label: 'All regions',
        areaId: 'all',
    },
    {
        label: 'Ireland',
        areaId: 'i',
    },
    {
        label: 'London',
        areaId: 'l',
    },
    {
        label: 'Midlands + East Anglia',
        areaId: 'mid',
    },
    {
        label: 'North East',
        areaId: 'ne',
    },
    {
        label: 'North West',
        areaId: 'nw',
    },
    {
        label: 'Northern Ireland',
        areaId: 'ni',
    },
    {
        label: 'South East',
        areaId: 'se',
    },
    {
        label: 'South West',
        areaId: 'sw',
    },
    {
        label: 'Scotland',
        areaId: 's',
    },
    {
        label: 'Wales',
        areaId: 'w',
    }
]